import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'
import { AdapterConfigureGenerico } from '../../AdapterConfigureGenerico'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { Items } from './Items'

export const logisticaApi = createApi({
    reducerPath: 'logisticaApi_',
    baseQuery: fetchBaseQuery({
        baseUrl: AdapterConfigureGenerico.URL_BASE_LOGISTICA,
        prepareHeaders: (headers) => {
            headers.set('Content-Type', 'application/json')
            headers.set('request-decrypt-response', 'true')
            return headers
        },
    }),
    tagTypes: ['Items'],
    endpoints: (build) => ({
        ...Items(build)
    })
})

export type LogisticaApiBuilder = EndpointBuilder<
    BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>,
    'Items',
    'logisticaApi_'
>;

export const {
    useFindItemsEspañaQuery,
    useLazyFindItemsEspañaQuery,
    useFindItemsQuery
} = logisticaApi
